import React from "react";

export const ScoreGauge = ({ score, size = 200 }) => {
  const stroke = 14;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score));
  const offset = c - (pct / 100) * c;
  return (
    <svg width={size} height={size} className="mx-auto block" data-testid="score-gauge">
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke="#EFEBE0"
        strokeWidth={stroke}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke="#D4AF37"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={c}
        strokeDashoffset={offset}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: "stroke-dashoffset 1s ease" }}
      />
      <text
        x="50%"
        y="47%"
        textAnchor="middle"
        dominantBaseline="middle"
        className="font-heading"
        fontSize={size * 0.3}
        fontWeight="700"
        fill="#0F172A"
      >
        {score}
      </text>
      <text
        x="50%"
        y="66%"
        textAnchor="middle"
        fontSize={size * 0.07}
        fontWeight="600"
        fill="#94A3B8"
        letterSpacing="2"
      >
        / 100
      </text>
    </svg>
  );
};

export const FactorBar = ({ label, score, highlight }) => (
  <div data-testid={`factor-bar-${label}`}>
    <div className="mb-1.5 flex items-center justify-between">
      <span className="text-sm font-semibold text-[#0F172A]">{label}</span>
      <span className="text-sm font-bold text-slate-500">{score}%</span>
    </div>
    <div className="h-2.5 w-full overflow-hidden rounded-full bg-slate-100">
      <div
        className="h-full rounded-full"
        style={{
          width: `${score}%`,
          background: highlight ? "#0F172A" : "#D4AF37",
          transition: "width 0.9s ease",
        }}
      />
    </div>
  </div>
);
